/**
 * PC_CDF_01 importing the api function calls
 */
import { useState, useEffect } from "react";
import React from "react";
import { getEmployeeCertificateInfo, postEmployeeCertificateInfo, getNotificationId } from "../service/DirectorAPI";
import moment from "moment";
import { Upload, uploadBackend } from "../utils/Upload";
import { useRef } from "react";
import Loader from '../StaticComponent/Loader';
import { OnlyNumberSpecialChar, NotificationTrigger } from '../../src/utils/RegHandling';
import $ from 'jquery';
import { connect } from 'react-redux'
import { encryptStorage } from '../constant'
import { getS3 } from '../utils/Download.js';

/**
 * 
 *  PC_CDF_03
 * CertificateDetails(props) this function return the HTML
 */
function CertificateDetails(props) {

    /**
     * PC_CDF_02 Declaring the state variables and objects
     */
    let dataObj = {
        id: "",
        CertifiedIn: "",
        CertifiedBy: "",
        DateOfCompletion: "",
        CertificateUrl: "",
        Specialization: ""
    };

    const [state, setState] = useState(dataObj);
    const [DisableSubmitBtn, setDisableSubmitBtn] = useState(false);

    let oldvalue = {
        CertifiedIn: "",
        CertifiedBy: "",
        DateOfCompletion: "",
        CertificateUrl: "",
        Specialization: ""
    }
    const [Oldvalue, setOldvalue] = useState(oldvalue);
    const [pagemode, setpagemode] = useState("false");
    const [EmpId, setEmpId] = useState("");
    const [submit, setSubmit] = useState("Save");
    const attachment = useRef()
    const [attachmentState, setattachmentState] = useState('');
    const [attachmentValidation, setattachmentValidation] = useState("")
    const [isLoading, setIsLoading] = useState(true);
    const [showUpload, setShowUpload] = useState(false);
    let validationFields = {
        CertifiedIn: "",
        CertifiedBy: "",
        DateOfCompletion: "",
        CertificateUrl: "",
        Specialization: ""

    }
    const [message, setmessage] = useState(validationFields);
    const [notification, setNotification] = useState([]);
    const [hideForm, setHideForm] = useState(true);
    let loginEmpId = encryptStorage.getItem("employeeId");
    let role = encryptStorage.getItem("role");
    const [reportstoId, setReportstoId] = useState("");



    /**
     * PC_CDF_02.1
     * useEffect method get invoked and make a selecteditarray() api call in edit mode
     */
    useEffect(() => {
        setDisableSubmitBtn(false);

        if (props.IsCertificateClicked) {

            $("body").addClass("removeScroll");

            setHideForm(false);

            if (props.empId != undefined) {
                setEmpId(props.empId)
            }
            if (props.Mode != undefined) {
                if (props.Mode == 'Edit') {
                    setpagemode('true')
                    setSubmit('Update')
                } else {
                    setpagemode('false')
                    setSubmit('Save')
                }
            }
            if (props.Id != undefined && props.Mode == 'Edit') {

                let objedit = {

                    emp_id: props.empId,
                    id: props.Id,
                    reports_to: loginEmpId,
                    role: role,
                };

                selecteditarray(objedit);
            }
        }

    }, [props])

    /**
     * 
     * PC_CDF_04.2 
     * this function will choose the file and validate the file size and format 
     */
    const bindAttachName = (e) => {
       
        setattachmentValidation("")
        message.CertificateUrl = ""
        setmessage({ ...message });
        setShowUpload(true);

        // 
        // 
        // 
        // 
        // 
        //
        setattachmentState(e.target.files[0].name);
        if (e.target.files[0].size >= 1000000) {

            setattachmentValidation("File size should be less than 1MB")

            attachment.current.value = '';
            return false
        }
        const typeArr = ['pdf', 'jpg', 'png', 'svg+xml', 'jpeg', 'svg']
        let type = typeArr.includes(e.target.files[0].type.split('/')[1])


        if (type == false) {

            setattachmentValidation("The uploaded file should be in PDF or JPG, PNG, JPEG, SVG format")
            attachment.current.value = '';
            return false
        }

        //setattachmentPopUp(true);
    };



    /**
     * 
     * PC_CDF_03 setstate the values into the state object
     */
    const OnChangeName = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
        setmessage({ ...message, [e.target.name]: "" })
    };


    /**
     * PC_CDF_04 
     * this function display the validation message when user submit the form without required fields
     */
    const validation = () => {

       

        if (state.CertifiedIn?.trim() == "") {

            message.CertifiedIn = "Certified In is Required"
            setmessage({ ...message });
        } else {
            message.CertifiedIn = ""
            setmessage({ ...message });

            let checkregex = OnlyNumberSpecialChar(state.CertifiedIn)
            if (checkregex) {

                message.CertifiedIn = "Enter a Valid Certified In"
                setmessage({ ...message });
            } else {
                message.CertifiedIn = ""
                setmessage({ ...message });

            }

        }
        if (state.CertifiedBy.trim() == "") {

            message.CertifiedBy = "Certified By is Required"
            setmessage({ ...message });

        } else {
            message.CertifiedBy = ""
            setmessage({ ...message });

            let checkregex = OnlyNumberSpecialChar(state.CertifiedBy)
            if (checkregex) {

                message.CertifiedBy = "Enter a Valid Certified By"
                setmessage({ ...message });
            } else {
                message.CertifiedBy = ""
                setmessage({ ...message });

            }

        }
        if (state.DateOfCompletion.trim() == "") {

            message.DateOfCompletion = "Date Of Completion is Required"
            setmessage({ ...message });

        } else {
            message.DateOfCompletion = ""
            setmessage({ ...message });

        }
        if (state.CertificateUrl.trim() == "") {
            if (attachmentState == "") {

                message.CertificateUrl = "Attachment is Required"
                setmessage({ ...message });

            } else {
                message.CertificateUrl = ""
                setmessage({ ...message });

            }
        } else {
            if (state.CertificateUrl.trim() == "") {

                message.CertificateUrl = "Attachment is Required"
                setmessage({ ...message });

            } else {
                message.CertificateUrl = ""
                setmessage({ ...message });

            }

        }

        if (state.Specialization.trim() == "") {

            message.Specialization = "Specialization is Required"
            setmessage({ ...message });

        } else {
            message.Specialization = ""
            setmessage({ ...message });

            let checkregex = OnlyNumberSpecialChar(state.Specialization)
            if (checkregex) {

                message.Specialization = "Enter a Valid Specialization"
                setmessage({ ...message });
            } else {
                message.Specialization = ""
                setmessage({ ...message });

            }

        }

    }
    /**
     * 
     * PC_CDF_04.3 
     * this function upload the file into the S3 bucket
     */
    const fileUpload = async (ref) => {
     
        let dirName = `${EmpId}-Profile-Certify`;
        setIsLoading(false);
        let file = attachment.current.files[0];
        if (file !== undefined && file != null) {

            let newFileName = attachment.current.files[0].name;
            if (newFileName !== undefined && newFileName != null) {
                let fileLocation = await uploadBackend(file, newFileName, dirName);
                return fileLocation
            } else {
                setIsLoading(true);
            }
        } else {
            setIsLoading(true);
        }
    };
    /**
     * PC_CDF_04.1
     * clear the fields when user clicks the cancel and close button
     */
    const cancelClick = () => {

        let valiclearoption = {
            id: "",
            CertifiedIn: "",
            CertifiedBy: "",
            DateOfCompletion: "",
            CertificateUrl: "",
            Specialization: ""
        };
        setState(valiclearoption);
        setattachmentState("");
        setShowUpload(false);

        let validationFields = {
            CertifiedIn: "",
            CertifiedBy: "",
            DateOfCompletion: "",
            CertificateUrl: "",
            Specialization: ""
        }
        setmessage(validationFields);
        props.setIsCertificateClicked(false);
        setattachmentValidation("");
        setHideForm(true);
        // let element = document.getElementById("removeScroll");
        // element.classList.remove("removeScroll");
        $("body").removeClass("removeScroll");
    }

    /**
     * PC_CDF_04.4
     * this function will remove the choosen file from attachment variable
     */
    const removeCertificate = () => {

        state.CertificateUrl = "";
        setState({ ...state })
        setattachmentState("");
        setattachmentValidation("");
        setShowUpload(false);
    }

    /***
     * PC_CDF_05
     * this function will post the data into the Data Base
     */

    const submitClick = async () => {
        try {
              setDisableSubmitBtn(true);
            validation();

            let isRejexValid = true;
            if (message.CertifiedBy != "" || message.CertifiedIn != "" || message.Specialization != "") {
                isRejexValid = false;
            } else {
                isRejexValid = true;
            }
            /**
             * PC_CDF_05.1 this will make a post call to insert the data into the batadase
             */

            if (pagemode == "false" && isRejexValid == true) {
                if (
                    state.CertifiedIn != "" &&
                    state.CertifiedBy != "" &&
                    state.DateOfCompletion != "" &&
                    state.Specialization != "" &&
                    message.CertificateUrl == "" &&
                    attachmentValidation == ""
                ) {
                    let certificateURL = await fileUpload()

                    let insertdata = {
                        request_type: "Insert", //
                        emp_id: EmpId, //
                        login_emp_id: loginEmpId, //
                        role: role,//
                        certification_in: state.CertifiedIn,
                        certified_by: state.CertifiedBy,
                        year_of_completion: state.DateOfCompletion,
                        certificate_url: certificateURL,
                        specialization: state.Specialization

                    };



                    let responsedata = await postEmployeeCertificateInfo(insertdata);
                    if (responsedata.data.status == 200) {
                        let valiclearoption = {
                            id: "",
                            CertifiedIn: "",
                            CertifiedBy: "",
                            DateOfCompletion: "",
                            CertificateUrl: "",
                            Specialization: ""
                        };
                        setState(valiclearoption);

                        props.setIsCertificateClicked(false);
                        props.getEmployeeCertificateGrid();
                        setattachmentState("");
                        setIsLoading(true);
                        setShowUpload(false);
                        cancelClick();
                        props.showToast('Submitted', 'Submitted Succesfully');
                    }

                }
            }
            /**
             * PC_CDF_23.1 if the role is HR Manager the update will made directly with proper payload
             */
            else if (pagemode == "true" && isRejexValid == true) {

                if (((role == "Hr Manager" || role == "Hr") && loginEmpId != EmpId) || (role == "Hr Manager" && loginEmpId == EmpId && reportstoId == loginEmpId)) {
                    if (
                        state.CertifiedIn != "" &&
                        state.CertifiedBy != "" &&
                        state.DateOfCompletion != "" &&
                        state.Specialization != "" &&
                        message.CertificateUrl == "" &&
                        attachmentValidation == ""

                    ) {
                        let certificateURL = await fileUpload()
                        let updatedata = {
                            request_type: "Update", //
                            emp_id: EmpId, //
                            login_emp_id: loginEmpId, //
                            role: role,//
                            id: state.id,
                            certification_in: state.CertifiedIn,
                            certified_by: state.CertifiedBy,
                            year_of_completion: state.DateOfCompletion,
                            certificate_url: certificateURL == undefined ? state.CertificateUrl : certificateURL,
                            specialization: state.Specialization

                        };


                        let responsedata = await postEmployeeCertificateInfo(updatedata);
                        if (responsedata.data.status == 200) {

                            let valiclearoption = {
                                id: "",
                                CertifiedIn: "",
                                CertifiedBy: "",
                                DateOfCompletion: "",
                                CertificateUrl: "",
                                Specialization: ""
                            };
                            setState(valiclearoption);

                            props.setIsCertificateClicked(false);
                            props.getEmployeeCertificateGrid();
                            setattachmentState("");
                            setIsLoading(true);
                            setShowUpload(false);
                            cancelClick();
                            props.showToast('Updated', 'Updated Succesfully');
                        }
                    }

                    /**
                     * PC_CDF_23.2if the role is Team Member
                     * dymamically binding the payload object for current and permanent address
                     */
                } else if (role == "Team Member" || loginEmpId == EmpId) {
                    if (
                        state.CertifiedIn != "" &&
                        state.CertifiedBy != "" &&
                        state.DateOfCompletion != "" &&
                        state.Specialization != "" &&
                        message.CertificateUrl == "" &&
                        attachmentValidation == ""
                    ) {

                        let certificateURL = await fileUpload()

                        let newvalue = {
                            certification_in: state.CertifiedIn,
                            certified_by: state.CertifiedBy,
                            year_of_completion: state.DateOfCompletion,
                            certificate_url: certificateURL == undefined ? state.CertificateUrl : certificateURL,
                            specialization: state.Specialization
                        }

                        let oldvalue = {
                            certification_in: Oldvalue.CertifiedIn,
                            certified_by: Oldvalue.CertifiedBy,
                            year_of_completion: Oldvalue.DateOfCompletion,
                            certificate_url: Oldvalue.CertificateUrl,
                            specialization: Oldvalue.Specialization
                        }

                        let NewValue = Object.keys(newvalue);
                        let OldValue = Object.keys(oldvalue);

                        let log_data = '{';
                        for (let i = 0; i <= NewValue.length; i++) {
                            if (newvalue[NewValue[i]] != oldvalue[OldValue[i]]) {

                                log_data += '"' + NewValue[i] + '"' + ':' + '"' + "'" + newvalue[NewValue[i]] + "'" + ',' + "'" + oldvalue[OldValue[i]] + "'" + '"' + ',';
                            }
                            if (i == NewValue.length) {

                                log_data = log_data.slice(0, -1);
                                log_data = log_data + "}";
                            }
                        }

                        if (log_data != '{' && log_data != '}') {
                            let logData = JSON.parse(log_data);

                            let updatedata = {
                                request_type: "Update",
                                emp_id: EmpId,
                                login_emp_id: loginEmpId,
                                category_id: state.id,
                                category: "emp_certification",
                                status: "Pending",
                                role: "Team Member",
                                log_data: logData

                            };

                            let emp = [];
                            notification.map((obj, index) => {

                                emp.push(obj.emp_id);
                            });

                            if (Object.keys(logData).length > 0) {

                                let responsedata = await postEmployeeCertificateInfo(updatedata);
                                if (responsedata.data.status == 200) {
                                    let profileRequestId = responsedata.data.ResponseData[1];
                                    await NotificationTrigger({ title: "Profile Update", message: 'Profile certificate Request', route: '/profileupdate', state: { state: { profileRequestId: profileRequestId } }, to_employee: emp, by: loginEmpId }, emp, props.websocket)

                                    let valiclearoption = {
                                        id: "",
                                        CertifiedIn: "",
                                        CertifiedBy: "",
                                        DateOfCompletion: "",
                                        CertificateUrl: "",
                                        Specialization: ""
                                    };
                                    setState(valiclearoption);
                                    props.setIsCertificateClicked(false);
                                    setattachmentState("");
                                    setIsLoading(true);
                                    setShowUpload(false);
                                    cancelClick();
                                    props.showToast('Profile Request submitted', 'Changes will be reflected after the approval');
                                }
                            }
                        } else { cancelClick(); }
                    }

                }
            }
            setDisableSubmitBtn(false);
        } catch (e) {

            setIsLoading(true);
            setDisableSubmitBtn(false);
        }

    }

    /**
     * 
     * PC_CDF_12
     * this function get the record from DB and bind into the respective fields 
     */

    const selecteditarray = async (objedit) => {

        try {
            let responsedata = await getEmployeeCertificateInfo(objedit);

            if (responsedata.data != undefined && responsedata.data != null && responsedata.data.ResponseData[0].length != 0) {

                let m = moment(new Date(responsedata.data.ResponseData[0][0].year_of_completion));
                let year_of_completion = m.format("YYYY-MM-DD");


                let oldvalueobj = {

                    CertifiedIn: responsedata.data.ResponseData[0][0].certification_in,
                    CertifiedBy: responsedata.data.ResponseData[0][0].certified_by,
                    DateOfCompletion: year_of_completion,
                    CertificateUrl: responsedata.data.ResponseData[0][0].certificate_url,
                    Specialization: responsedata.data.ResponseData[0][0].specialization
                };
                setOldvalue(oldvalueobj);

                let valiDateobj1 = {
                    id: responsedata.data.ResponseData[0][0].id,
                    CertifiedIn: responsedata.data.ResponseData[0][0].certification_in,
                    CertifiedBy: responsedata.data.ResponseData[0][0].certified_by,
                    DateOfCompletion: year_of_completion,
                    CertificateUrl: responsedata.data.ResponseData[0][0].certificate_url,
                    Specialization: responsedata.data.ResponseData[0][0].specialization

                };
                setState(valiDateobj1);

                if (responsedata.data.ResponseData[0][0].certificate_url != "") {
                    setShowUpload(true);
                }
            }

            let NotaficationData = await getNotificationId(objedit);
            setNotification(NotaficationData.data.ResponseData[0]);
            setReportstoId(NotaficationData?.data?.ResponseData[0][0]?.emp_id);

        } catch (e) {

        }
    };



    return (
        <div
            className="modal fade show"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }}
            hidden={hideForm}
            //id="CertificateDetailsPopup" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="CertificateDetailsPopupLabel" aria-hidden="true"
        >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <Loader isLoading={isLoading} />
                    <div className="modal-header border-0">
                        <h5 className="modal-title profile-popup-header" id="CertificateDetailsPopupLabel">
                            Certificates
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => cancelClick()}
                        />
                    </div>
                    <div className="modal-body">
                        <div className="row mb-1">
                            <div className="col-md-6 mb-4">
                                <label htmlFor="certificate-certifiedin" className="form-label hive-form-label">
                                    Certified In<span className="hive-form-mandatory">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control hive-form-control"
                                    id="certificate-certifiedin"
                                    aria-describedby="Certified In"
                                    placeholder="Enter here"
                                    maxLength={255}
                                    name="CertifiedIn"
                                    value={state.CertifiedIn}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                />
                                {message.CertifiedIn ? <label className="hive-form-mandatory">{message.CertifiedIn}</label> : null}
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="certificate-Certifiedby" className="form-label hive-form-label">
                                    Certified By<span className="hive-form-mandatory">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control hive-form-control"
                                    id="certificate-Certifiedby"
                                    aria-describedby="Certified By"
                                    placeholder="Enter here"
                                    maxLength={255}
                                    name="CertifiedBy"
                                    value={state.CertifiedBy}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                />
                                {message.CertifiedBy ? <label className=" hive-form-mandatory">{message.CertifiedBy}</label> : null}
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="certificate-date" className="form-label hive-form-label">
                                    Date of Completion<span className="hive-form-mandatory">*</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control hive-form-control"
                                    id="certificate-date"
                                    aria-describedby="Date of Completion"
                                    name="DateOfCompletion"
                                    value={state.DateOfCompletion}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                />
                                {message.DateOfCompletion ? (
                                    <label className=" hive-form-mandatory">{message.DateOfCompletion}</label>
                                ) : null}
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="certificate-upload" className="form-label  hive-form-label">
                                    Upload Certification<span className="hive-form-mandatory">*</span>
                                </label>

                                <div className="">
                                    <div className="custom-upload-btn-wrapper" hidden={showUpload}>
                                        {/* <button className="btn bold-text font-12 custom-upload-btn" >
                                            <span className="me-2">
                                                <img src="/Images/UpoadArrow.svg" alt="upload-arrow" />
                                            </span>Upload</button> */}

                                        <label
                                            htmlFor="certificate-Upload"
                                            className="profile-custom-file-upload"
                                            style={{ marginRight: '65%' }}
                                        >
                                            <img className="me-2" src="Images/profile-upload-icon.svg" alt="Upload Icon" />
                                            Upload
                                        </label>

                                        <input
                                            id="certificate-Upload"
                                            type="file"
                                            className="profile-file-upload"
                                            name="attachement_url"
                                            ref={attachment}
                                            onChange={(e) => bindAttachName(e)}
                                        />
                                    </div>

                                    {state.CertificateUrl ? (
                                        <div>
                                            <a
                                                className="text-decoration-none "
                                                style={{cursor:"pointer"}} onClick={async () => {
                                                    window.open(await getS3(state.CertificateUrl), "_blank");
                                                }} 
                                                target={'_blank'}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title={state.CertificateUrl.substring(59)}
                                            >
                                                <img
                                                    src="/Images/profile-certificate-attachment.svg"
                                                    alt="Attachment Icon"
                                                    className="p-1"
                                                />
                                                {state.CertificateUrl.substring(59).length > 20
                                                    ? state.CertificateUrl.substring(59).substring(0, 20)
                                                    : state.CertificateUrl.substring(59)}
                                            </a>
                                            <span>
                                                {' '}
                                                <img
                                                    src="/Images/profile-certificate-cancel.svg"
                                                    className="cursor-pointer"
                                                    alt="Cancel Icon"
                                                    onClick={() => removeCertificate()}
                                                />
                                            </span>
                                        </div>
                                    ) : null}

                                    {attachmentState ? (
                                        <div>
                                            <a
                                                className="text-decoration-none "
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title={attachmentState}
                                            >
                                                <img
                                                    src="/Images/profile-certificate-attachment.svg"
                                                    alt="Attachment Icon"
                                                    className="p-1"
                                                />
                                                {attachmentState.length > 20 ? attachmentState.substring(0, 20) : attachmentState}
                                            </a>
                                            <span>
                                                {' '}
                                                <img
                                                    src="/Images/profile-certificate-cancel.svg"
                                                    className="cursor-pointer"
                                                    alt="Cancel Icon"
                                                    onClick={() => removeCertificate()}
                                                />
                                            </span>
                                        </div>
                                    ) : null}

                                    <div>
                                        {message.CertificateUrl ? (
                                            <label className="hive-form-mandatory">{message.CertificateUrl}</label>
                                        ) : null}
                                        {attachmentValidation ? (
                                            <label className="hive-form-mandatory">{attachmentValidation}</label>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="certificate-Certifiedby" className="form-label hive-form-label">
                                    Specialization<span className="hive-form-mandatory">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control hive-form-control"
                                    id="certificate-Certifiedby"
                                    aria-describedby="Certified By"
                                    placeholder="Enter here"
                                    maxLength={255}
                                    name="Specialization"
                                    value={state.Specialization}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                />
                                {message.Specialization ? <label className="hive-form-mandatory">{message.Specialization}</label> : null}
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer border-0">
                        <button type="button" className="btn hive-btn-secondary" data-bs-dismiss="modal" onClick={() => cancelClick()}>
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn hive-btn-primary"
                            onClick={() => {
                                submitClick();
                            }}
                            disabled={DisableSubmitBtn}
                        >
                            {submit}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {

    return {
        websocket: state.webSocketAPI
    }
}

export default connect(mapStateToProps)(CertificateDetails)